export default __webpack_public_path__ + "static/media/projTrack6.0c7508df.png";